import React from 'react';

function FancyBorder(props: any) {
	return (
		<div className={'FancyBorder FancyBorder-' + props.color}>
			{props.children}
		</div>
	);
}

export default class Welcome extends React.Component<any, any> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(props: any) {
		super(props);
	}
	
	render() {
		return (
			<FancyBorder color="blue">
				<h1 className="Dialog-title">Welcome</h1>
				<p className="Dialog-message">Thank you for visiting our spacecraft!</p>
			</FancyBorder>
		);
	}
}
